module.exports = __webpack_public_path__ + "img/frozen_carrot_diced.370e471d.jpg";